export default __webpack_public_path__ + "static/media/icone-atividade-hover.08aa21bb.svg";